import React from 'react';
import PropTypes from 'prop-types';

const ChannelFacebook = ({ monochrome, ...props }) => (
  <svg viewBox="0 0 26 26" height="1em" {...props}>
    <circle cx="13" cy="13.2" r="12.8" fill="white" />
    <path
      d="M26 13C26 5.81953 20.1805 0 13 0C5.81953 0 0 5.81953 0 13C0 20.1805 5.81953 26 13 26C13.0762 26 13.1523 26 13.2285 25.9949V15.8793H10.4355V12.6242H13.2285V10.2273C13.2285 7.44961 14.9246 5.93633 17.4027 5.93633C18.591 5.93633 19.6117 6.02266 19.9062 6.06328V8.96797H18.2C16.8543 8.96797 16.5902 9.60781 16.5902 10.5473V12.6191H19.8148L19.3934 15.8742H16.5902V25.4973C22.0238 23.9383 26 18.9363 26 13Z"
      fill={monochrome ? 'currentColor' : '#1777f2'}
    />
  </svg>
);

ChannelFacebook.propTypes = {
  monochrome: PropTypes.bool,
};
ChannelFacebook.defaultProps = {
  monochrome: false,
};

export default ChannelFacebook;
